import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8aaff9aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["disabled"]

import { withDefaults } from "vue";
import type { ButtonHTMLAttributes } from "vue";
import Spinner from "@/components/Spinner.vue";

interface IProps extends ButtonHTMLAttributes {
	loading?: boolean;
	type?: "submit" | "reset" | "button" | undefined;
	variant?: "primary" | "secondary";
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    loading: { type: Boolean, default: false },
    type: null,
    variant: { default: "primary" }
  },
  emits: ["click"],
  setup(__props: any, { emit }) {

const props = __props as { loading: boolean, type?: "submit" | "reset" | "button" | undefined, variant: "primary" | "secondary" }





return (_ctx: any,_cache: any) => {
  return (props.type === 'submit')
    ? (_openBlock(), _createElementBlock("button", _mergeProps({ key: 0 }, props, {
        class: ["button", {
			'primary-variant': __props.variant === 'primary',
			'secondary-variant': __props.variant === 'secondary',
		}],
        disabled: props.disabled || props.loading
      }), [
        (props.loading)
          ? (_openBlock(), _createBlock(Spinner, {
              key: 0,
              class: "w-6 h-6 mr-4"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 16, _hoisted_1))
    : (_openBlock(), _createElementBlock("button", _mergeProps({ key: 1 }, props, {
        class: ["button", {
			'primary-variant': __props.variant === 'primary',
			'secondary-variant': __props.variant === 'secondary',
		}],
        disabled: props.disabled || props.loading,
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => emit('click'), ["prevent"]))
      }), [
        (props.loading)
          ? (_openBlock(), _createBlock(Spinner, {
              key: 0,
              class: "w-6 h-6 mr-4"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 16, _hoisted_2))
}
}

})